module.exports = __webpack_public_path__ + "static/media/aijaz.c227f401.jpg";